// extracted by mini-css-extract-plugin
export default {"blackscreen":"PromoSection_blackscreen__2Lupg"};